import { z } from 'zod';

export const TobaccoUse = z.enum(['YES', 'NO']);

export type TobaccoUse = z.infer<typeof TobaccoUse>;
